import React from "react";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Button,
} from "reactstrap";
import AuthFooter from "components/Footers/AuthFooter.js";
import logo from "../../assets/img/logo1.jpg";
import ZambiaTrainingTable from "components/Tables/ZambiaTrainingTable.js";

const GOLD = "#c9a227";
const DARK = "#1a1a1a";

const fabBase = {
  width: "46px",
  height: "46px",
  borderRadius: "50%",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
  fontSize: "18px",
  transition: "transform 0.15s, opacity 0.2s",
};

export default function ZambiaTrainingCalendar() {
  const [navbarColor] = React.useState("info");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [showScrollTop, setShowScrollTop] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 350);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const handleAppClick = () => {
    if (collapseOpen) {
      document.documentElement.classList.toggle("nav-open");
      setCollapseOpen(false);
    }
  };

  return (
    <div>
      <div id="app">
        <h1 className="sr-only">Zambia Training Calendar</h1>
        <Navbar
          className={"fixed-top " + navbarColor}
          expand="lg"
          style={{ marginTop: 0 }}
        >
          <Container>
            <div className="navbar-translate">
              <NavbarBrand href="/" data-placement="bottom">
                <div className="d-flex">
                  <img
                    alt="Course App"
                    src={logo}
                    style={{
                      height: "40px",
                      width: "auto",
                      borderRadius: "4px",
                      marginRight: "5px",
                    }}
                  />
                  <h3
                    style={{
                      fontWeight: 600,
                      textDecoration: "none",
                      textTransform: "capitalize",
                      fontSize: "22px",
                    }}
                  >
                    GSR TRAINING CONSULTING
                  </h3>
                </div>
              </NavbarBrand>
            </div>
            <div
              className="phone-view-hide"
              style={{ marginRight: "20px" }}
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(true);
              }}
              aria-expanded={collapseOpen}
            >
              <i className="fa fa-bars" style={{ color: "white" }} />
            </div>
            <Collapse className="justify-content-end" isOpen={collapseOpen} navbar>
              <Nav navbar>
                <NavItem>
                  <NavLink tag="a" href="/" className="mr-3">
                    HOME
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag="a" href="/overseas-training-calendar" className="mr-3">
                    OVERSEAS CALENDAR
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="mt--2"
                    href="/zambia-training-calendar"
                    style={{
                      fontWeight: "700",
                      color: DARK,
                      backgroundColor: GOLD,
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    ZAMBIA CALENDAR
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>

        <div onClick={handleAppClick}>
          <div style={{ marginTop: "150px", marginBottom: "100px" }}>
            <Container>

              {/* Page header */}
              <div
                style={{
                  backgroundColor: DARK,
                  borderRadius: "8px",
                  padding: "30px 36px",
                  marginBottom: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
              >
                <div>
                  <p style={{ color: GOLD, fontWeight: "700", letterSpacing: "2px", fontSize: "12px", marginBottom: "4px", textTransform: "uppercase" }}>
                    Zambia Team
                  </p>
                  <h2 style={{ color: "#fff", fontWeight: "800", fontSize: "28px", marginBottom: "4px" }}>
                    2026 – 2027 Training Calendar
                  </h2>
                  <p style={{ color: "#aaa", marginBottom: 0, fontSize: "14px" }}>
                    30 programs &nbsp;·&nbsp; All 3-day sessions &nbsp;·&nbsp; June 2026 – April 2027
                  </p>
                </div>
                <a
                  href="/calendar/zambia/Training_Schedule_Zambia_2026_2027.pdf"
                  download="Training_Schedule_Zambia_2026_2027.pdf"
                >
                  <Button
                    style={{
                      backgroundColor: GOLD,
                      borderColor: GOLD,
                      color: DARK,
                      fontWeight: "700",
                    }}
                  >
                    <i className="fa fa-download mr-2" />
                    Download Full Schedule
                  </Button>
                </a>
              </div>

              {/* Table */}
              <div className="row">
                <div className="col-sm-12">
                  <div style={{ borderRadius: "8px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
                    <ZambiaTrainingTable />
                  </div>
                </div>
              </div>

            </Container>
          </div>
          <AuthFooter />
        </div>

        {/* Floating action buttons */}
        <div
          style={{
            position: "fixed",
            bottom: "32px",
            right: "28px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            zIndex: 1000,
          }}
        >
          {/* Scroll to top — only visible after scrolling down */}
          <button
            onClick={scrollToTop}
            title="Back to top"
            style={{
              ...fabBase,
              backgroundColor: DARK,
              color: GOLD,
              opacity: showScrollTop ? 1 : 0,
              pointerEvents: showScrollTop ? "auto" : "none",
              transform: showScrollTop ? "translateY(0)" : "translateY(12px)",
            }}
          >
            <i className="fa fa-arrow-up" />
          </button>

          {/* Download — always visible */}
          <a
            href="/calendar/zambia/Training_Schedule_Zambia_2026_2027.pdf"
            download="Training_Schedule_Zambia_2026_2027.pdf"
            title="Download Full Schedule"
            style={{ textDecoration: "none" }}
          >
            <button
              style={{
                ...fabBase,
                backgroundColor: GOLD,
                color: DARK,
              }}
            >
              <i className="fa fa-download" />
            </button>
          </a>
        </div>

      </div>
    </div>
  );
}
